import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import cn from 'classnames';
import { FTInput } from '../Fuse/Text';
import ConsoleStore from '../../stores/ConsoleStore';
import { IS_BROWSER_IE11, IS_BROWSER_ON_MAC } from '../../env';
import Icon from '../Icon/Icon';
import { Key } from '../../mirror/userInput';
import ConsoleCustomerSelectStore from '../../stores/ConsoleCustomerSelectStore';
import UDSpinner from '../UD/Fragments/UDSpinner';
import './FuseConsoleCustomerSelect.css';

const block = b.lock('FuseConsoleCustomerSelect');

const SCROLLABLE_LIST_MIN_ITEMS_COUNT = 6;

class FuseConsoleCustomerSelect extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        customerSelect: ConsoleCustomerSelectStore.PropType.isRequired,
    };

    optionRefs = [];

    componentDidMount() {
        if (this.listPickerElement) {
            this.listPickerElement.addEventListener('keydown', this.handleKeyDown);
        }
    }

    componentWillUnmount() {
        if (this.listPickerElement) {
            this.listPickerElement.removeEventListener('keydown', this.handleKeyDown);
        }
    }

    handleKeyDown = (event) => {
        const {
            dropdown,
            focus,
            hovered } = this.props.customerSelect;


        if (!focus.isTrue && !dropdown.isOpen) {
            return;
        }

        if (event.keyCode === Key.SPACE || event.keyCode === Key.ENTER) {
            if (!dropdown.isOpen || hovered == null) {
                this.toggleList(event);
            } else if (dropdown.isOpen && hovered !== null && event.keyCode === Key.ENTER) {
                this.props.customerSelect.setSelectedCustomer(null);
            }
        }

        if (event.keyCode === Key.DOWN || event.keyCode === Key.UP) {
            event.stopPropagation();
            event.preventDefault();
            // const selectedIndex = fixedOptions.findIndex( (option) => option.id === );

            if (!dropdown.isOpen) {
                dropdown.show();
            } else if (hovered === null) {
                this.props.customerSelect.setHovered(0);
            } else if (hovered !== null) {
                this.props.customerSelect.setHovered(event.keyCode === Key.DOWN ? hovered + 1 : hovered - 1);
                this.optionRefs[hovered].scrollIntoView(event.keyCode === Key.DOWN);
            }
        }

        if (event.keyCode === Key.ESC && dropdown.isOpen) {
            event.stopPropagation();
            event.preventDefault();

            this.toggleList(event, dropdown.isOpen);
        }
    };

    onRef = (element) => {
        this.listPickerElement = element;
    };

    onSearchInputRef = (element) => {
        this.searchInputElement = element;
    };

    onOptionRef = (element, index) => {
        this.optionRefs[index] = element;
    };

    onFocusChange = (event, focus) => {
        let relatedTarget = event.nativeEvent.relatedTarget;
        if (IS_BROWSER_IE11 && relatedTarget === null) {
            relatedTarget = document.activeElement;
        }
        if (!this.listPickerElement ? relatedTarget === this.searchInputElement :
            this.listPickerElement !== relatedTarget && this.listPickerElement.contains(relatedTarget)) {
            return;
        }
        this.props.customerSelect.setFocusClearHoveredAndClose(focus);
    };

    toggleList = (event, force = false) => {
        const { dropdown } = this.props.customerSelect;
        if (this.searchInputElement && this.searchInputElement.contains(event.target) && !force) {
            return;
        }
        this.props.customerSelect.toggleList();
        if (dropdown.isOpen) {
            setTimeout(() => {
                if (this.searchInputElement) {
                    this.searchInputElement.focus();
                }
            }, 100);
        }
    };

    onSearchInputFocusChange = (event, focus) => {
        event.preventDefault();
        event.stopPropagation();

        let relatedTarget = event.nativeEvent.relatedTarget;
        if (IS_BROWSER_IE11 && relatedTarget === null) {
            relatedTarget = document.activeElement;
        }
        if (this.listPickerElement && this.listPickerElement.contains(relatedTarget)) {
            return;
        }
        if (!focus) {
            this.props.customerSelect.setFocusClearHoveredAndClose(focus);
        }
    };

    onSearch = (event) => {
        this.props.customerSelect.filter.onChangeHandler(event.nativeEvent);
    };

    onClearSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.searchInputElement) {
            this.searchInputElement.value = '';
        }
        this.props.customerSelect.filter.onChangeHandler({ target: this.searchInputElement });
        this.searchInputElement.focus();
    };

    renderOption = ({ id, displayName }, index) => {
        const { hovered } = this.props.customerSelect;
        return <div
            key={id}
            ref={(element) => this.onOptionRef(element, index)}
            className={block('Option', {
                selected: id === this.props.customerSelect.customerId,
                hover: hovered === index,
            })}
            onClick={() => this.props.customerSelect.setSelectedCustomer(id)}
        >
            <span className={block('OptionLabel')}>{`${displayName} (ID: ${id})`}</span>
        </div>;
    };


    render() {
        const { console, customerSelect } = this.props;

        const { filter, dropdown, focus, customerList } = customerSelect;
        const open = dropdown.isOpen;
        const showListScrollable = IS_BROWSER_ON_MAC && customerList.length >= SCROLLABLE_LIST_MIN_ITEMS_COUNT;

        if (!console.isConsoleAdmin
            || !customerSelect.customerList
            || customerSelect.customerList.length <= 1) {
            return <FTInput className={block('NoAdmin')}>{console.customerName}</FTInput>;
        }

        return <div
            ref={this.onRef}
            tabIndex={open ? 0 : -1}
            className={cn(block({ focus: focus.value, open }))}
        >
            <div
                className={block('FocusHack')}
                tabIndex={open ? -1 : 0}// onSearchInputFocusChange not working properly
                onFocus={(event) => this.onFocusChange(event, true)}
                onBlur={(event) => this.onFocusChange(event, false)}
            />
            <div className={block('ControlFrame')}>
                <div className={block('SelectButton')} onClick={this.toggleList}>
                    {!open
                        ? <span
                            title={customerSelect.customerName}
                            className={block('SelectLabel', { loading: customerSelect.apiSetState.isLoading })}
                        >
                            {customerSelect.customerName}
                        </span> : <Fragment>
                            <Icon className={block('SearchIcon')} type="search" />
                            <input
                                ref={this.onSearchInputRef}
                                value={filter.value}
                                className={block('SearchInput')}
                                onFocus={(event) => this.onSearchInputFocusChange(event, true)}
                                onBlur={(event) => this.onSearchInputFocusChange(event, false)}
                                placeholder={'Search'}
                                tabIndex={-1}
                                onChange={this.onSearch}
                            />
                            {filter.value && !IS_BROWSER_IE11 ? (
                                <Icon
                                    className={block('ClearIcon')}
                                    type="cancel"
                                    onClick={this.onClearSearch}
                                />
                            ) : null}
                        </Fragment>
                    }
                </div>
                {customerSelect.apiSetState.isLoading ? <UDSpinner
                    className={block('Loader')}
                    iconClassName={block('Spinner')}
                    type="fuse"
                /> : null}
            </div>
            {open ? <div className={block('OptionsContainer', { scrollable: showListScrollable })}>
                <div className={block('OptionList')} >
                    {customerSelect.filteredCustomerList.map((option, index) => this.renderOption(option, index))}
                    {customerSelect.filteredCustomerList.length === 0 ? <div className={block('NoOptionsLabel')}>
                        {'No options'}
                    </div> : null}
                </div>
            </div> : null}
        </div>;
    }
}

export default translate()(inject('console', 'customerSelect')(observer(FuseConsoleCustomerSelect)));
